var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgSurvey02(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 180,
    viewBox: "0 0 78 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "py9j1lmlcb",
    x1: "64.648%",
    x2: "41.36%",
    y1: "101.241%",
    y2: "18.364%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#213F80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#23AF4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6q0budnife",
    x1: "16.013%",
    x2: "127.759%",
    y1: "-11.886%",
    y2: "129.964%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#23B04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#214081"
  })), /*#__PURE__*/React.createElement("path", {
    id: "v50lakdwea",
    d: "M0 2.773v51.372C0 66.122 4.49 77.666 12.59 86.52l16.55 18.087h.128v-.694L13.008 86.14C4.982 77.37.563 66.008.563 54.145V2.773C.564 1.389 1.702.56 2.802.56c.433 0 1.065.127 1.614.727l24.852 27.16v-.834L4.833.909C4.258.28 3.523 0 2.802 0 1.376 0 0 1.095 0 2.773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "737078t0ud",
    d: "M2.776 0C.37 0-.893 2.863.728 4.645l96.437 106.04c.13.144.262.286.396.426V41.988l-26.037-28.63C63.786 4.85 52.827 0 41.337 0H2.777z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-165.000000, -1200.000000) translate(144.000000, 126.000000) translate(0.000000, 1074.000000) translate(35.717480, 127.425474) scale(-1, 1) translate(-35.717480, -127.425474) translate(21.083333, 74.850949)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f5aavdes0c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v50lakdwea"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#py9j1lmlcb)",
    d: "M0 2.773v51.372C0 66.122 4.49 77.666 12.59 86.52l16.55 18.087h.128v-.694L13.008 86.14C4.982 77.37.563 66.008.563 54.145V2.773C.564 1.389 1.702.56 2.802.56c.433 0 1.065.127 1.614.727l24.852 27.16v-.834L4.833.909C4.258.28 3.523 0 2.802 0 1.376 0 0 1.095 0 2.773",
    mask: "url(#f5aavdes0c)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-165.000000, -1200.000000) translate(144.000000, 126.000000) translate(0.000000, 1074.000000) translate(49.644309, 56.000000) scale(-1, 1) translate(-49.644309, -56.000000) translate(0.644309, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kl32s0asdf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#737078t0ud"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#6q0budnife)",
    d: "M2.776-.542C.37-.542-.893 2.321.728 4.103l76.437 86.04c.13.144.262.286.396.426V21.446l-6.037-8.63C63.786 4.309 52.827-.541 41.337-.541H2.777z",
    mask: "url(#kl32s0asdf)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgSurvey02);
export default __webpack_public_path__ + "static/media/bg_survey_02.c92197bef749e5fc674be3ec8b2251af.svg";
export { ForwardRef as ReactComponent };